import { Helmet } from 'react-helmet';
import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Container, Row, Col, Alert } from 'react-bootstrap';
import { getUserProfile, updateUserProfile, updatePassword } from '../api';

// List of US states

function UserProfile() {
  const title = 'Profile';

  const [profile, setProfile] = useState({
    username:'',
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
   
  });
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const response = await getUserProfile();
      setProfile(response.data);
    } catch (error) {
      setError('Error fetching user profile');
    }
  };

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^(\+1|1)?[-.\s]?\(?[2-9]\d{2}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneRegex.test(phoneNumber);
  };

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const validateProfile = () => {
    const errors = {};
    if (!profile.username.trim()) errors.username = 'Username is required';
    if (!profile.firstname.trim()) errors.firstname = 'First name is required';
    if (!profile.lastname.trim()) errors.lastname = 'Last name is required';
    if (!profile.phone.trim()) errors.phone = 'Phone number is required';
    else if (!validatePhoneNumber(profile.phone)) errors.phone = 'Please enter a valid US phone number';
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!validateProfile()) {
      setError('Please correct the errors in the form');
      return;
    }

    try {
      await updateUserProfile(profile);
      setSuccess('Profile updated successfully');
    } catch (error) {
      setError('Error updating profile');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (!validatePassword(password)) {
      setError('Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character');
      return;
    }

    try {
      await updatePassword({ password });
      setSuccess('Password updated successfully');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      setError('Error updating password');
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container fluid className="d-flex flex-column mb-5 px-3">
        <Row className="justify-content-center g-5 pt-3">
          <Col md={6}>
            <Card>
              <Card.Header className="bg-white">
                <h4 className="text-secondary">Contact Information</h4>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={handleProfileSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>User Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      value={profile.username}
                      onChange={handleProfileChange}
                      isInvalid={!!validationErrors.username}
                      required
                      disabled
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.username}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="firstname"
                          value={profile.firstname}
                          onChange={handleProfileChange}
                          isInvalid={!!validationErrors.firstname}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {validationErrors.firstname}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastname"
                          value={profile.lastname}
                          onChange={handleProfileChange}
                          isInvalid={!!validationErrors.lastname}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {validationErrors.lastname}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={profile.email}
                          onChange={handleProfileChange}
                          required
                          disabled
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={profile.phone}
                          onChange={handleProfileChange}
                          isInvalid={!!validationErrors.phone}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {validationErrors.phone}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                 
                  <Button type="submit" variant="primary">Update Profile</Button>
                </Form>
              </Card.Body>
            </Card>

            <Card className="mt-4">
              <Card.Header className="bg-white">
                <h4 className="text-secondary">Password Update</h4>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={handlePasswordSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Confirm New Password</Form.Label>
                        <Form.Control
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Text className="text-muted">
                    Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.
                  </Form.Text><br></br>
                  <Button type="submit" variant="primary" className="mt-3">Update Password</Button>
                </Form>
              </Card.Body>
            </Card>

            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {success && <Alert variant="success" className="mt-3">{success}</Alert>}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default UserProfile;